module.exports = __webpack_public_path__ + "img/icons8-cadillac.25789936.svg";